export default __webpack_public_path__ + "static/snow-6e0649525614f8fdb55b9eb73fded752.jpg";